import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateOrUpdatePaymentMethodForm from "../../forms/CreateOrUpdatePaymentMethodForm";

const CreatePaymentMethodModal = ({ open, onClose, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Add Payment Method"
    width="md"
    loading={loading}
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <CreateOrUpdatePaymentMethodForm loading={loading} />
  </AppModal>
);

export default CreatePaymentMethodModal;
